// extracted by mini-css-extract-plugin
module.exports = {"partnershipForm":"styles_partnershipForm__3ETGl","separated":"styles_separated__2DxKW","formTextBlock":"styles_formTextBlock__1HGZJ","bottom":"styles_bottom__24HEj"};